import { render, staticRenderFns } from "./collar.vue?vue&type=template&id=7aa917ab&"
import script from "./collar.vue?vue&type=script&lang=js&"
export * from "./collar.vue?vue&type=script&lang=js&"
import style0 from "./collar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports